export default {
  // Navbar
  nav_home: "Home",
  nav_excursions: "Excursions",
  nav_reviews: "Reviews",
  nav_contact: "Follow Us",
  nav_book_now: "Book Now",
  nav_menu: "Menu",
  nav_whatsapp: "WhatsApp",

  // Hero
  hero_badge: "One of the best places to book your Tenerife adventure",
  hero_title_1: "Discover Tenerife.",
  hero_title_2: "Live the Adventure.",
  hero_subtitle: "From volcanic buggy expeditions to world-class theme parks \u2014 book unforgettable tours and tickets across the Canary Islands with local experts you can trust.",
  hero_cta_explore: "Explore Excursions",
  hero_cta_talk: "Talk to a Local Expert",
  hero_badge_local_support: "Local Support",
  hero_badge_local_support_sub: "in 3 languages",
  hero_badge_secure: "Secure Booking",
  hero_badge_secure_sub: "trusted & verified",

  // Categories
  cat_title: "Browse by Category",
  cat_heading: "Every kind of Tenerife adventure",
  cat_subtitle: "From volcanic hikes to whale watching, our curated categories help you find the perfect experience.",
  cat_bus: "Bus Excursions",
  cat_parks: "Theme Parks",
  cat_tickets: "Tickets",
  cat_boat: "Boat Trips",
  cat_adventure: "Adventure & Nature",
  cat_water: "Water Activities",
  cat_food: "Gastronomy",
  cat_rental: "Car & Bike Rental",
  cat_activities: "activities",

  // Excursions List
  el_badge: "Featured Experiences",
  el_heading: "Handpicked Tenerife excursions",
  el_subtitle: "Our most booked adventures this month \u2014 from adrenaline rides to family-friendly parks.",
  el_view_all: "View all excursions",
  el_explore_all_btn: "Explore All Excursions",
  el_explore_all_sub: "Browse all categories \u2014 adventure, boat trips, water sports & more",
  exall_badge: "All Excursions",
  exall_heading: "Explore All Tenerife Excursions",
  exall_subtitle: "Every adventure, show and water activity we offer \u2014 filter by category or browse them all.",
  exall_filter_all: "All",
  exall_results_label: "excursions found",
  exall_no_results: "No excursions found in this category.",
  el_from: "From",
  el_view_details: "View Details",
  el_pickup: "Pick-up",
  el_accessible: "Accessible",

  // Why Us
  wu_badge: "Why book with us",
  wu_heading: "Your trusted Tenerife excursion partner",
  wu_subtitle: "We're a Tenerife excursion agency with a simple mission: help you experience the very best of the island without the tourist traps.",

  wu_local_experts: "Local Tenerife experts",
  wu_local_experts_body: "Agency based in El Médano — our guides live and breathe the island.",
  wu_languages: "Local support in 3 languages",
  wu_languages_body: "We speak Polish, English and Spanish. No language barriers, just great service.",
  wu_handpicked: "Handpicked experiences",
  wu_handpicked_body: "Every tour and ticket is personally tested and selected for quality, fun and value.",
  wu_personal: "Personal itinerary help",
  wu_personal_body: "Not sure what to pick? Message us on WhatsApp and we'll build a custom plan for you.",

  // Testimonials (homepage)
  tm_badge: "Real Reviews",
  tm_heading: "What our customers say",
  tm_subtitle: "Genuine reviews from travellers who booked directly through us — shared on Facebook in their own words.",
  tm_based_on: "based on Facebook reviews",
  tm_source_fb: "Recommended on Facebook",
  tm_show_more: "Read more",
  tm_show_less: "Show less",
  tm_see_more_fb: "See more reviews on Facebook",

  // Reviews
  rev_badge: "Customer Reviews",
  rev_heading: "What our travellers say",
  rev_subtitle: "Real reviews from real people who booked with us across all our excursions.",
  rev_rating_label: "verified reviews",
  rev_1_title: "Absolute adrenaline rush!",
  rev_1_body: "Best day of our Tenerife holiday. Our guide was hilarious and the volcanic landscape is unreal. The Polaris RZR is a beast \u2014 highly recommend!",
  rev_2_title: "Best park we've visited",
  rev_2_body: "It's the best park I've been to, well worth the money. Very clean, animals were amazing, food was really good. A great day out!",
  rev_3_title: "Great combo deal",
  rev_3_body: "Yani helped us book \u2014 very kind and helpful. The combo ticket was great value and we had so much fun at both parks.",
  rev_4_title: "Great customer service",
  rev_4_body: "The staff were extremely helpful in every way, had a great trip, would recommend booking through them for trips out.",
  rev_5_title: "Everything was perfect!",
  rev_5_body: "Everything ran smoothly, from the transfer to the entrance. Both parks are world class \u2014 Siam Park especially blew our minds.",
  rev_6_title: "Volcanic terrain is stunning",
  rev_6_body: "Riding through the moon-like Teide landscape was surreal. The tapas & wine tasting afterwards was the perfect ending.",

  // Contact CTA
  ct_badge: "Stay Connected",
  ct_social_heading: "Follow our adventures",
  ct_social_subtitle: "See daily photos, stories and behind-the-scenes moments from Tenerife. Tag us in your excursions!",
  ct_subtitle: "Tell us what you're looking for \u2014 a Tenerife local will get back to you within a few hours with a personalized itinerary.",
  ct_whatsapp_label: "WhatsApp",
  ct_whatsapp_number: "+48 792 842 613",
  ct_whatsapp_hours: "07:00 \u2013 21:00 daily",
  ct_form_heading: "Send us your request",
  ct_form_subtitle: "We'll craft the perfect Tenerife experience for you.",
  ct_form_name: "Your name",
  ct_form_email: "Email",
  ct_form_interested: "Interested in",
  ct_form_date: "Preferred date",
  ct_form_message: "Message",
  ct_form_message_placeholder: "Tell us about your group, dates, hotel...",
  ct_form_send: "Send Request",
  ct_form_sending: "Sending...",
  ct_success_title: "Thanks, we got it!",
  ct_success_body: "A local expert will reach out within a few hours.",
  ct_form_error: "Something went wrong. Please try again.",
  ct_form_network_error: "Network error. Please check your connection and try again.",
  ct_option_buggy: "Buggy Volcano Expedition",
  ct_option_jungle: "Jungle Park Tickets",
  ct_option_twin: "Twin Ticket (Loro + Siam)",
  ct_option_fishing: "Sea Fishing Trip",
  ct_option_custom: "Custom itinerary",

  // Footer
  ft_tagline: "Discover Tenerife with curated tours, tickets and unforgettable adventures across the island. Trusted by thousands of travellers.",
  ft_contact: "Contact",
  ft_whatsapp: "WhatsApp",
  ft_whatsapp_number: "+48 792 842 613",
  ft_phone_local_label: "Local (Tenerife)",
  ft_hours: "07:00 \u2013 21:00 (Daily)",
  ft_location: "El Médano, Tenerife, Canary Islands",
  ft_explore: "Explore",
  ft_all_excursions: "All Excursions",
  ft_buggy: "Buggy Volcano Tour",
  ft_jungle: "Jungle Park Tickets",
  ft_twin: "Twin Ticket Combo",
  ft_reviews: "Customer Reviews",
  ft_social: "Follow Us",
  ft_social_text: "More photos, stories and updates on our social channels.",
  ft_copyright: "\u00a9 2026 Mateo Teneryfa. All rights reserved.",
  ft_privacy: "Privacy Policy",
  ft_cookies: "Cookie Policy",
  ft_terms: "Terms & Conditions",

  // Excursion page
  ex_home: "Home",
  ex_excursions: "Excursions",
  ex_what_youll_do: "What you'll do",
  ex_highlights: "Highlights",
  ex_included: "Included",
  ex_recommendations: "Recommendations",
  ex_requirements: "Requirements",
  ex_schedule: "Show Schedule",
  ex_hours: "Opening hours",
  ex_languages: "Available languages",
  ex_reviews: "Customer reviews",
  ex_related: "You might also like",
  ex_more: "More experiences",
  ex_see_all: "See all",
  ex_small_group: "Small group",
  ex_pickup: "Pick-up",
  ex_accessible: "Accessible",
  ex_duration: "Duration",
  ex_yes: "Yes",
  ex_no: "No",
  ex_not_found_title: "Excursion not found",
  ex_not_found_body: "The activity you're looking for doesn't exist.",
  ex_back_home: "Back to home",

  // Booking Widget
  bw_manage: "Manage your booking",
  bw_book: "Book",
  bw_option: "Choose an option",
  bw_date: "Select date",
  bw_adults: "Adults",
  bw_children: "Children",
  bw_infants: "Infants",
  bw_total: "Total price",
  bw_add_cart: "Add to Cart",
  bw_book_now: "Book Now",
  bw_added_msg: "Added! A local expert will confirm your booking within a few hours.",
  bw_instant: "Secure booking — trusted by thousands",
  bw_secure: "Secure payment",

  // Language
  lang_pl: "Polski",
  lang_en: "English",
  lang_es: "Espa\u00f1ol",
  lang_modal_title: "Choose your language",
  lang_modal_subtitle: "Select your preferred language to continue",

  // Booking Form Modal
  bfm_title: "Complete your booking",
  bfm_success_title: "Booking request sent!",
  bfm_success_body: "Thanks! We've received your booking details and will be in touch shortly.",
  bfm_excursion: "Excursion",
  bfm_date: "Date",
  bfm_guests: "Guests",
  bfm_name: "Full name",
  bfm_name_placeholder: "Your full name",
  bfm_email: "Email",
  bfm_email_placeholder: "your@email.com",
  bfm_phone: "Phone / WhatsApp",
  bfm_message: "Special requests",
  bfm_message_placeholder: "Hotel name, pickup location, dietary needs...",
  bfm_submit: "Send booking request",
  bfm_sending: "Sending...",

  // Excursion titles
  "ex_title_buggy-volcano": "Buggy Volcano Expedition — 3 Hours",
  "ex_title_jungle-park": "Jungle Park Wildlife — Arona, Tenerife",
  "ex_title_twin-ticket": "Twin Ticket — Loro Parque + Siam Park",

  // Excursion subtitles
  "ex_subtitle_buggy-volcano": "Polaris RZR Off-Road Adventure Around Mount Teide",
  "ex_subtitle_jungle-park": "Meet exotic wildlife, raptors and majestic big cats",
  "ex_subtitle_twin-ticket": "Two of the best theme parks in the world in a single ticket",

  // Category labels (used in cards and breadcrumbs)
  cat_adventure_nature: "Adventure & Nature",
  cat_parks_tickets: "Theme Parks & Tickets",

  // Reviews word
  ex_reviews_word: "reviews",

  // Duration per excursion
  "ex_dur_buggy-volcano": "3 hrs",
  "ex_dur_jungle-park": "4 – 5 hrs",
  "ex_dur_twin-ticket": "5 hrs",

  // Variant labels
  "ex_var_buggy-volcano_0": "Single buggy",
  "ex_var_buggy-volcano_1": "Double buggy",
  "ex_var_jungle-park_0": "Adult ticket",
  "ex_var_jungle-park_1": "Child (5 – 10 yrs)",
  "ex_var_jungle-park_2": "Infant (3 – 4 yrs)",
  "ex_var_twin-ticket_0": "Twin Ticket Adult",
  "ex_var_twin-ticket_1": "Twin Ticket Resident",
  "ex_var_twin-ticket_2": "Twin Ticket + Bus to Loro Parque",
  "ex_var_twin-ticket_3": "Transfer to Loro Parque",
  "ex_var_twin-ticket_4": "Transfer Siam Bus from Puerto de la Cruz",

  // Schedule names (Jungle Park)
  "ex_sch_jungle-park_0": "Exotic Birds Show",
  "ex_sch_jungle-park_1": "Birds of Prey Show",
  "ex_sch_jungle-park_2": "Sea Lions Show",
  "ex_sch_jungle-park_3": "Penguins Feeding",

  // Park hours (Twin Ticket)
  "ex_hrs_twin-ticket_0_name": "Loro Parque",
  "ex_hrs_twin-ticket_0_info": "8:30 – 18:45, 365 days a year",
  "ex_hrs_twin-ticket_1_name": "Siam Park (May – Oct)",
  "ex_hrs_twin-ticket_1_info": "10:00 – 18:00",
  "ex_hrs_twin-ticket_2_name": "Siam Park (Nov – Apr)",
  "ex_hrs_twin-ticket_2_info": "10:00 – 17:00",

  // BookingWidget
  bw_whatsapp_support: "WhatsApp support:",
  bw_local_phone: "Local (Tenerife):",

  // Excursion Requirements
  "ex_req_buggy-volcano_0": "Standard driving license required",
  "ex_req_buggy-volcano_1": "Drivers under 23 years old must leave a \u20ac250 deposit",
  "ex_req_twin-ticket_0": "Twin Ticket uses digital fingerprint access system",

  // Excursion Included
  "ex_inc_buggy-volcano_0": "Pick-up &amp; drop-off",
  "ex_inc_buggy-volcano_1": "Bottled water",
  "ex_inc_buggy-volcano_2": "Anti-dust goggles",
  "ex_inc_buggy-volcano_3": "Warm jackets and gloves (if needed)",
  "ex_inc_buggy-volcano_4": "Basic vehicle insurance",
  "ex_inc_buggy-volcano_5": "Unforgettable driving experience",
  "ex_inc_jungle-park_0": "Full entrance ticket",
  "ex_inc_jungle-park_1": "Free shuttle bus from South Tenerife",
  "ex_inc_twin-ticket_0": "Entrance to Loro Parque",
  "ex_inc_twin-ticket_1": "Entrance to Siam Park",
  "ex_inc_twin-ticket_2": "Immediate confirmation voucher",

  // Excursion Highlights
  "ex_hl_buggy-volcano_0": "Hotel pick-up and drop-off included, stress-free transfer",
  "ex_hl_buggy-volcano_1": "Professional safety training before setting off",
  "ex_hl_buggy-volcano_2": "15 minutes of pure adrenaline on a dedicated volcanic track",
  "ex_hl_buggy-volcano_3": "Optional wine tasting &amp; Canarian tapas after the ride",
  "ex_hl_jungle-park_0": "Free-flight show with eagles, falcons and birds of prey",
  "ex_hl_jungle-park_1": "Meet the incredible white tiger, alligators, monkeys &amp; lions",
  "ex_hl_jungle-park_2": "Beautifully recreated jungle environment",
  "ex_hl_jungle-park_3": "Free bus service from Los Cristianos, Las Am\u00e9ricas &amp; Costa Adeje",
  "ex_hl_twin-ticket_0": "Loro Parque \u2014 the world&apos;s best zoo with the largest parrot collection",
  "ex_hl_twin-ticket_1": "Siam Park \u2014 Europe&apos;s largest water park with tropical Thai theming",
  "ex_hl_twin-ticket_2": "Special combined pricing, save vs. individual tickets",
  "ex_hl_twin-ticket_3": "15 days validity between the two visits",

  // Excursion Taglines
  "ex_tagline_buggy-volcano": "Ride the most powerful Polaris RZR buggies across volcanic trails on Tenerife.",
  "ex_tagline_jungle-park": "A different kind of zoo focused on jungle wildlife: birds of prey, falcons, eagles and exotic animals of every kind.",
  "ex_tagline_twin-ticket": "Combined ticket to visit Loro Parque and Siam Park \u2014 voted best zoo and best water park in the world by TripAdvisor users.",

  // Excursion Recommendations
  "ex_rec_buggy-volcano_0": "Wear comfortable shoes and clothes",
  "ex_rec_buggy-volcano_1": "Bring a jacket, it can get cold in the mountains",
  "ex_rec_buggy-volcano_2": "Apply sunscreen \u2014 Tenerife sun is intense, especially in summer",
  "ex_rec_jungle-park_0": "Arrive early to catch the exotic birds show at 11:00",
  "ex_rec_jungle-park_1": "Comfortable walking shoes recommended",
  "ex_rec_twin-ticket_0": "Book bus transfers at least 24 hours in advance",
  "ex_rec_twin-ticket_1": "Free train from Puerto de la Cruz to Loro Parque",

  // ─── New categories ────────────────────────────────────────────────────────
  cat_boat_trips: "Boat Trips",
  cat_water_activities: "Water Activities",
  cat_entertainment: "Entertainment",

  // ─── Two Parks Ticket ──────────────────────────────────────────────────────
  "ex_title_two-parks-ticket": "Two Parks Ticket \u2014 Jungle Park + Aqualand",
  "ex_subtitle_two-parks-ticket": "Visit two incredible theme parks in one combined ticket",
  "ex_tagline_two-parks-ticket": "Two parks, one ticket, zero hassle. Jungle Park lets you walk among white tigers, eagles and exotic creatures in a lush tropical setting, then Aqualand takes over with adrenaline-pumping slides, splash zones and a lazy river to cool off. Use the ticket across different days — no need to cram it all into one afternoon.",
  "ex_dur_two-parks-ticket": "6 hrs",
  "ex_hl_two-parks-ticket_0": "Get up close with big cats, birds of prey and tropical animals in Jungle Park's natural enclosures",
  "ex_hl_two-parks-ticket_1": "Aqualand's best bits: the giant wave pool, twisting body slides and the long lazy river",
  "ex_hl_two-parks-ticket_2": "One ticket = both parks. You keep more cash in your pocket vs buying separately",
  "ex_hl_two-parks-ticket_3": "Spread your visits over different days — there's no rush to do everything at once",
  "ex_inc_two-parks-ticket_0": "Entrance to Jungle Park",
  "ex_inc_two-parks-ticket_1": "Entrance to Aqualand Costa Adeje",
  "ex_inc_two-parks-ticket_2": "Immediate confirmation voucher",
  "ex_rec_two-parks-ticket_0": "Pack swimwear, a towel and sunscreen — you'll want all three at Aqualand",
  "ex_rec_two-parks-ticket_1": "Hit Jungle Park in the morning while the animals are most active, then cool off at Aqualand after lunch",
  "ex_var_two-parks-ticket_0": "Adult ticket",
  "ex_var_two-parks-ticket_1": "Child ticket",

  // ─── Jeep Safari La Gomera ────────────────────────────────────────────────
  "ex_title_jeep-safari-la-gomera": "Jeep Safari \u2014 La Gomera Island",
  "ex_subtitle_jeep-safari-la-gomera": "Discover the wild nature and scenic roads of La Gomera by 4x4 Jeep",
  "ex_tagline_jeep-safari-la-gomera": "Hop on a morning ferry, then spend the day bouncing through La Gomera in an open-top 4x4. You'll weave between banana valleys, hike through misty UNESCO laurel forests and stop at mountain villages most tourists never see. A proper Canarian lunch rounds it all off before the ferry back.",
  "ex_dur_jeep-safari-la-gomera": "9 hrs",
  "ex_hl_jeep-safari-la-gomera_0": "Hermigua valley — terraced banana fields and a sleepy village wedged between two mountains",
  "ex_hl_jeep-safari-la-gomera_1": "Laguna Grande — a wide-open mountain viewpoint where the island stretches out below you",
  "ex_hl_jeep-safari-la-gomera_2": "Garajonay National Park — walk through ancient laurel forest that's been here since the dinosaurs",
  "ex_hl_jeep-safari-la-gomera_3": "Agulo viewpoint — the island's prettiest balcony, looking straight at Teide across the ocean",
  "ex_hl_jeep-safari-la-gomera_4": "Lunch stop at a family-run spot — simple, homemade and absolutely delicious",
  "ex_inc_jeep-safari-la-gomera_0": "Ferry both ways",
  "ex_inc_jeep-safari-la-gomera_1": "4x4 Jeep (max 8 people per Jeep)",
  "ex_inc_jeep-safari-la-gomera_2": "Professional local guide",
  "ex_inc_jeep-safari-la-gomera_3": "Hotel pick-up and drop-off",
  "ex_inc_jeep-safari-la-gomera_4": "OC insurance",
  "ex_rec_jeep-safari-la-gomera_0": "Comfortable shoes are a must — you'll be hopping in and out of the Jeep all day",
  "ex_rec_jeep-safari-la-gomera_1": "South-side pickup runs Mon, Wed, Fri. North side: Mon and Wed only",
  "ex_var_jeep-safari-la-gomera_0": "Adult (South)",
  "ex_var_jeep-safari-la-gomera_1": "Child 2-11 yrs (South)",
  "ex_var_jeep-safari-la-gomera_2": "Adult (North)",
  "ex_var_jeep-safari-la-gomera_3": "Child 2-11 yrs (North)",

  // ─── Helicopter Flights ──────────────────────────────────────────────────
  "ex_title_helicopter-flights": "Helicopter Scenic Flights \u2014 Tenerife",
  "ex_subtitle_helicopter-flights": "See Tenerife from above \u2014 5 stunning routes to choose from",
  "ex_tagline_helicopter-flights": "Nothing prepares you for what Tenerife looks like from the sky. One minute you're hovering above golden beaches, the next you're staring into Teide's volcanic crater. Pick from five different routes — whether you want a quick coastal buzz or a full-on flight circling the entire volcano. The views through those big windows are absolutely unreal.",
  "ex_dur_helicopter-flights": "8 \u2013 50 min",
  "ex_hl_helicopter-flights_0": "Five totally different routes — from a quick 8-minute coastal loop to a full 50-minute Teide experience",
  "ex_hl_helicopter-flights_1": "Shorter flights give you that first-time helicopter rush with gorgeous beach and cliff scenery",
  "ex_hl_helicopter-flights_2": "Longer flights take you deep into the island — volcanic craters, lava fields and the Teno mountains",
  "ex_hl_helicopter-flights_3": "Floor-to-ceiling windows so every seat gets a perfect shot for photos and video",
  "ex_inc_helicopter-flights_0": "Scenic helicopter flight",
  "ex_inc_helicopter-flights_1": "Safety briefing and equipment",
  "ex_req_helicopter-flights_0": "Weight limit per flight applies \u2014 please enquire when booking",
  "ex_rec_helicopter-flights_0": "Summer seats vanish fast. If you've got specific dates, lock them in as early as you can",
  "ex_var_helicopter-flights_0": "South Coast \u2014 8-9 min",
  "ex_var_helicopter-flights_1": "Beaches & Canyons \u2014 12-15 min",
  "ex_var_helicopter-flights_2": "Beaches, Canyons & Cliffs \u2014 20-22 min",
  "ex_var_helicopter-flights_3": "Beaches, Canyons, Cliffs & Teno \u2014 35-40 min",
  "ex_var_helicopter-flights_4": "Teide & Surroundings \u2014 45-50 min",

  // ─── Catamaran Dolphin Watching ──────────────────────────────────────────
  "ex_title_catamaran-dolphin-watching": "Catamaran Dolphin & Whale Watching \u2014 4.5 hrs",
  "ex_subtitle_catamaran-dolphin-watching": "Sail along the stunning western coast and search for dolphins and whales",
  "ex_tagline_catamaran-dolphin-watching": "A proper afternoon on the water. The catamaran glides west along the coast toward those enormous Los Gigantes cliffs while you keep your eyes peeled for dolphins and pilot whales — they hang out in these waters year-round. Halfway through, the crew drops anchor for a swim stop with the cliffs towering above you. Tuesday and Sunday pickups cover both the south and north of the island.",
  "ex_dur_catamaran-dolphin-watching": "4.5 hrs",
  "ex_hl_catamaran-dolphin-watching_0": "Sail the western coastline — the catamaran heads straight for the Los Gigantes cliffs",
  "ex_hl_catamaran-dolphin-watching_1": "Dolphins and pilot whales are residents here, not visitors — sightings are super common",
  "ex_hl_catamaran-dolphin-watching_2": "Mid-trip swimming stop right beneath the cliffs in ridiculously clear water",
  "ex_hl_catamaran-dolphin-watching_3": "Hotel pickup from both south and north every Tuesday and Sunday",
  "ex_inc_catamaran-dolphin-watching_0": "Catamaran sailing trip",
  "ex_inc_catamaran-dolphin-watching_1": "Marine biologist guide on board",
  "ex_rec_catamaran-dolphin-watching_0": "Swimwear and towel are non-negotiable — you'll regret not jumping in",
  "ex_rec_catamaran-dolphin-watching_1": "These trips fill up quick, especially in high season. Book a few days ahead if you can",
  "ex_var_catamaran-dolphin-watching_0": "Adult (South)",
  "ex_var_catamaran-dolphin-watching_1": "Child 5-11 yrs (South)",

  // ─── Pirate Ship Los Gigantes ────────────────────────────────────────────
  "ex_title_pirate-ship-los-gigantes": "Pirate Ship Dolphin Watching \u2014 Los Gigantes",
  "ex_subtitle_pirate-ship-los-gigantes": "3-hour adventure from Los Gigantes port on the legendary Flipper Uno pirate ship",
  "ex_tagline_pirate-ship-los-gigantes": "The Flipper Uno isn't your average tour boat — it's a proper wooden pirate ship that turns heads every time it leaves Los Gigantes port. Three hours on board: spot dolphins with the marine biologist, jump into the ocean for a swim under those massive cliffs, then sit down for paella, grilled chicken and a cold drink. Twice daily departures, up to 90 people, and the vibe is always upbeat.",
  "ex_dur_pirate-ship-los-gigantes": "3 hrs",
  "ex_hl_pirate-ship-los-gigantes_0": "The Flipper Uno itself — a real wooden pirate ship that's become a Los Gigantes icon",
  "ex_hl_pirate-ship-los-gigantes_1": "A marine biologist joins every trip to help you spot and identify dolphins and whales",
  "ex_hl_pirate-ship-los-gigantes_2": "Swimming stop right where the cliffs meet the sea — water doesn't get much clearer",
  "ex_hl_pirate-ship-los-gigantes_3": "Freshly cooked lunch on deck: paella, chicken, wine, beer and soft drinks included",
  "ex_inc_pirate-ship-los-gigantes_0": "Red wine, beer, soft drinks and water on board",
  "ex_rec_pirate-ship-los-gigantes_0": "Two sailings every day: 11:30 and 14:30. The afternoon one catches gorgeous golden light",
  "ex_rec_pirate-ship-los-gigantes_1": "Bring a camera, your swimmers and a bit of energy — this isn't a quiet sightseeing cruise",
  "ex_var_pirate-ship-los-gigantes_0": "Adult",
  "ex_var_pirate-ship-los-gigantes_1": "Child 2-11 yrs",
  "ex_var_pirate-ship-los-gigantes_2": "Infant 0-2 yrs",

  // ─── Night Skies Tenerife ─────────────────────────────────────────────────
  "ex_title_night-skies-tenerife": "Night Skies Tenerife \u2014 Stargazing at Teide",
  "ex_subtitle_night-skies-tenerife": "Stargaze with telescopes in the incredible night sky of Teide National Park",
  "ex_tagline_night-skies-tenerife": "Teide National Park sits above the clouds, far from any light pollution — making it one of the best places on Earth to look at the stars. A guide walks you through the night sky with a laser pointer powerful enough to touch the Milky Way, while telescopes bring Saturn's rings and distant galaxies right up to your eye. Sunset option available if you want the full golden-to-starry transition.",
  "ex_dur_night-skies-tenerife": "3 \u2013 4 hrs",
  "ex_hl_night-skies-tenerife_0": "Teide National Park after dark — zero light pollution, just you and a sky full of stars",
  "ex_hl_night-skies-tenerife_1": "Powerful green laser tours — your guide literally draws constellations across the Milky Way",
  "ex_hl_night-skies-tenerife_2": "Proper telescopes set up so you can see Saturn, Jupiter and deep-space objects up close",
  "ex_hl_night-skies-tenerife_3": "Pickup from your hotel in the south — no need to navigate mountain roads at night",
  "ex_inc_night-skies-tenerife_0": "Hotel pick-up and drop-off from South Tenerife",
  "ex_inc_night-skies-tenerife_1": "Expert astronomy guide",
  "ex_req_night-skies-tenerife_0": "Bring warm clothing \u2014 temperatures at altitude drop significantly at night",
  "ex_req_night-skies-tenerife_1": "Comfortable footwear recommended for uneven volcanic terrain",
  "ex_rec_night-skies-tenerife_0": "Tours run in English \u2014 Spanish, German, Dutch and Chinese available on request",
  "ex_var_night-skies-tenerife_0": "Sunset & Stars \u2014 Self Drive",
  "ex_var_night-skies-tenerife_1": "Star Safari (No Dinner)",
  "ex_var_night-skies-tenerife_2": "Star Safari (Dinner Included)",

  // ─── Ol\u00e9 Flamenco Show ─────────────────────────────────────────────────────
  "ex_title_ole-flamenco-show": "Ol\u00e9 Flamenco Show \u2014 Costa Adeje",
  "ex_subtitle_ole-flamenco-show": "An evening of Spanish dance, passion and colour at Hotel GF Victoria",
  "ex_tagline_ole-flamenco-show": "Thursday nights at Hotel GF Victoria belong to flamenco. The show is run by Fran Chafino, a dancer who's performed all over Spain, and his troupe brings everything — stomping footwork, soaring vocals, live guitar and raw emotion. You can grab the Oro ticket for the show alone, or go Platino and add a pre-show dinner. Either way, be in your seat by 20:30.",
  "ex_dur_ole-flamenco-show": "2 hrs",
  "ex_hl_ole-flamenco-show_0": "Fran Chafino's dance company — these are serious performers, not a tourist dinner show",
  "ex_hl_ole-flamenco-show_1": "The full flamenco spectrum: solo guitar pieces, group dance numbers and heart-stopping vocal moments",
  "ex_hl_ole-flamenco-show_2": "Every Thursday evening at Hotel GF Victoria in Costa Adeje — reception opens at 20:30",
  "ex_hl_ole-flamenco-show_3": "Oro for the show, Platino if you want dinner included before the curtain goes up",
  "ex_inc_ole-flamenco-show_0": "Entrance to the flamenco show",
  "ex_req_ole-flamenco-show_0": "No photos or videos allowed during the performance",
  "ex_rec_ole-flamenco-show_0": "Show kicks off at 21:00 sharp. Get there by 20:30 to grab a drink and settle in",
  "ex_rec_ole-flamenco-show_1": "Smart casual is the move — you're at a nice hotel, not the beach",
  "ex_var_ole-flamenco-show_0": "Oro \u2014 Adult",
  "ex_var_ole-flamenco-show_1": "Oro \u2014 Child (3-11 yrs)",
  "ex_var_ole-flamenco-show_2": "Platino \u2014 Adult",
  "ex_var_ole-flamenco-show_3": "Platino \u2014 Child (3-11 yrs)",

  // ─── Jet Ski Los Gigantes ────────────────────────────────────────────────
  "ex_title_jet-ski-los-gigantes": "Jet Ski Los Gigantes \u2014 Blue Safari",
  "ex_subtitle_jet-ski-los-gigantes": "Guided jet ski tour from Los Gigantes to Punta de Teno with two exclusive stops",
  "ex_tagline_jet-ski-los-gigantes": "An hour on a jet ski along Tenerife's wildest stretch of coast. You launch from Los Gigantes port with a guide leading the way, cut through the Atlantic toward the Masca ravine, then push on to Punta de Teno — a remote cape where the island ends and nothing but ocean stretches ahead. Two stops to catch your breath, take photos, and soak it all in before heading back.",
  "ex_dur_jet-ski-los-gigantes": "1 hr",
  "ex_hl_jet-ski-los-gigantes_0": "Launch from Los Gigantes port and ride straight toward the Barranco de Masca",
  "ex_hl_jet-ski-los-gigantes_1": "Two stops along the way — Masca ravine and the dramatic Punta de Teno lighthouse",
  "ex_hl_jet-ski-los-gigantes_2": "Ride solo or bring someone on the back — individual and double skis available",
  "ex_hl_jet-ski-los-gigantes_3": "Neoprene suits, life jackets and a full safety rundown before you hit the water",
  "ex_inc_jet-ski-los-gigantes_0": "Life jacket",
  "ex_inc_jet-ski-los-gigantes_1": "Neoprene suit",
  "ex_inc_jet-ski-los-gigantes_2": "Changing rooms",
  "ex_inc_jet-ski-los-gigantes_3": "Locker",
  "ex_inc_jet-ski-los-gigantes_4": "Towel",
  "ex_inc_jet-ski-los-gigantes_5": "Showers",
  "ex_inc_jet-ski-los-gigantes_6": "Security briefing",
  "ex_inc_jet-ski-los-gigantes_7": "Civil liability and accident insurance",
  "ex_req_jet-ski-los-gigantes_0": "Minimum height to ride: 1.35 m",
  "ex_req_jet-ski-los-gigantes_1": "Maximum weight per jet ski: 200 kg",
  "ex_req_jet-ski-los-gigantes_2": "Basic swimming knowledge required",
  "ex_req_jet-ski-los-gigantes_3": "Not recommended for pregnant women or people with heart, back or joint conditions",
  "ex_var_jet-ski-los-gigantes_0": "Individual jet ski",
  "ex_var_jet-ski-los-gigantes_1": "Double jet ski",

  // ─── VIP Private Tour Tenerife
  "ex_title_vip-tour-tenerife": "VIP Private Tour \u2014 Tenerife",
  "ex_subtitle_vip-tour-tenerife": "Discover the real Tenerife at your own pace with a private guide",
  "ex_tagline_vip-tour-tenerife": "Forget rigid bus schedules and crowded viewpoints. This is your own private car with a driver-guide who knows every back road, hidden lookout and family-run restaurant on the island. You call the shots — stop for photos whenever you want, skip what doesn't interest you, linger where it does. Eight hours of Tenerife, your way.",
  "ex_dur_vip-tour-tenerife": "8 hrs",
  "ex_hl_vip-tour-tenerife_0": "Just you and your group — no strangers, no waiting around for other people",
  "ex_hl_vip-tour-tenerife_1": "Your guide takes you to spots the big coaches can't reach — quiet viewpoints and local secrets",
  "ex_hl_vip-tour-tenerife_2": "The route bends around your interests, not the other way round. Change plans mid-day if you feel like it",
  "ex_hl_vip-tour-tenerife_3": "Comfortable private car, door-to-door service, and a guide who actually listens to what you want",
  "ex_hl_vip-tour-tenerife_4": "Pickup from anywhere on the island — your hotel, apartment, even the airport",
  "ex_inc_vip-tour-tenerife_0": "Private vehicle with driver-guide",
  "ex_inc_vip-tour-tenerife_1": "Pick-up from any location on the island",
  "ex_rec_vip-tour-tenerife_0": "Tours run Monday to Friday",
  "ex_rec_vip-tour-tenerife_1": "\u20ac30 surcharge for pick-up from Puerto de La Cruz, Santa Cruz or Candelaria",
  "ex_var_vip-tour-tenerife_0": "2 people",
  "ex_var_vip-tour-tenerife_1": "3 people",
  "ex_var_vip-tour-tenerife_2": "4 people",
  "ex_var_vip-tour-tenerife_3": "5+ people",

  // ─── Kayak Los Gigantes ──────────────────────────────────────────────────
  "ex_title_kayak-los-gigantes": "Kayak Los Gigantes \u2014 Cliffs & Ocean",
  "ex_subtitle_kayak-los-gigantes": "Explore the majestic Los Gigantes cliffs by kayak \u2014 a raw ocean experience",
  "ex_tagline_kayak-los-gigantes": "Paddling a kayak under those 600-metre cliffs is humbling — they don't look real from water level. A quick boat shuttle takes you from the port to the launch point, then you spend two hours gliding along the base of Los Gigantes, dipping into hidden coves and drifting through water so clear you can see the seabed below. Small groups only, and the afternoon light makes the rock faces glow.",
  "ex_dur_kayak-los-gigantes": "2 hrs",
  "ex_hl_kayak-los-gigantes_0": "Paddle right underneath the cliffs — you can practically touch the volcanic rock face",
  "ex_hl_kayak-los-gigantes_1": "The cliffs drop 600 metres straight into the ocean. They're even more impressive from a kayak",
  "ex_hl_kayak-los-gigantes_2": "Kept to small groups so it never feels crowded or rushed",
  "ex_hl_kayak-los-gigantes_3": "Boat shuttle from the port to the paddling zone and back — no tiring approaches",
  "ex_inc_kayak-los-gigantes_0": "Drinks",
  "ex_inc_kayak-los-gigantes_1": "Shower",
  "ex_inc_kayak-los-gigantes_2": "Kayak equipment",
  "ex_inc_kayak-los-gigantes_3": "Boat transfer to kayaking area and back",
  "ex_req_kayak-los-gigantes_0": "Swimming ability required",
  "ex_req_kayak-los-gigantes_1": "Not recommended for people with back or joint conditions",
  "ex_var_kayak-los-gigantes_0": "Adult \u2014 13:00 session",
  "ex_var_kayak-los-gigantes_1": "Child (6-9 yrs) \u2014 13:00 session",

  // ─── Paragliding Tenerife ─────────────────────────────────────────────────
  "ex_title_paragliding-tenerife": "Paragliding Tenerife \u2014 Tandem Flights",
  "ex_subtitle_paragliding-tenerife": "Tandem paragliding above the Atlantic coast \u2014 Bronze, Silver & Acrobatic",
  "ex_tagline_paragliding-tenerife": "There are very few things on Earth that match the feeling of lifting off a mountain and floating above the Atlantic with Tenerife spread out below you. Choose the Bronze package for a 10\u201320 minute first flight from 800 m, step up to Silver for 20\u201340 minutes with an optional higher launch from Ifonche, or throw yourself into the Acrobatic package for spirals, wingovers and dynamic manoeuvres over the ocean. A +\u20ac30 photo & video pack is available for any flight so you have something to show for it.",
  "ex_dur_paragliding-tenerife": "10 \u2013 40 min",
  "ex_hl_paragliding-tenerife_0": "Bronze 110\u20ac \u2014 launch from 800 m, 10\u201320 minutes, perfect for first-timers",
  "ex_hl_paragliding-tenerife_1": "Silver 130\u20ac \u2014 800 m or Ifonche (1000 m) launch, 20\u201340 minutes of flight time. Ifonche = automatic Silver",
  "ex_hl_paragliding-tenerife_2": "Acrobatic 140\u20ac \u2014 max altitude, spirals and wingovers over the ocean for thrill-seekers",
  "ex_hl_paragliding-tenerife_3": "Photo & video pack +30\u20ac \u2014 available for every flight so the memories last",
  "ex_hl_paragliding-tenerife_4": "Fly tandem with a certified instructor \u2014 no experience needed whatsoever",
  "ex_inc_paragliding-tenerife_0": "Tandem flight with certified instructor",
  "ex_inc_paragliding-tenerife_1": "Paragliding harness and safety equipment",
  "ex_inc_paragliding-tenerife_2": "Pre-flight safety briefing",
  "ex_req_paragliding-tenerife_0": "Weight limit: 30\u2013110 kg per passenger \u2014 please inform us when booking",
  "ex_req_paragliding-tenerife_1": "Not recommended for people with heart conditions or severe vertigo",
  "ex_rec_paragliding-tenerife_0": "Wear comfortable closed-toe shoes and light layers \u2014 it can be breezy at altitude",
  "ex_rec_paragliding-tenerife_1": "Flights depend on weather \u2014 we\u2019ll confirm your slot the day before and offer a full reschedule if winds aren\u2019t right",
  "ex_var_paragliding-tenerife_0": "Bronze \u2014 10-20 min",
  "ex_var_paragliding-tenerife_1": "Silver \u2014 20-40 min",
  "ex_var_paragliding-tenerife_2": "Acrobatic \u2014 max altitude",
  "ex_var_paragliding-tenerife_3": "+ Photo & Video Pack (any flight)",

  // ─── Yacht Cruise Puerto Colón ───────────────────────────────────────────
  "ex_title_yacht-cruise-puerto-colon": "Yacht Cruise \u2014 3 Hours from Puerto Col\u00f3n",
  "ex_subtitle_yacht-cruise-puerto-colon": "Exclusive 3-hour yacht cruise with drinks, dolphin watching and a swim stop",
  "ex_tagline_yacht-cruise-puerto-colon": "Three hours aboard a private yacht out of Puerto Col\u00f3n \u2014 and with a max of just 11 people on deck, if you roll with your whole crew you basically have the boat to yourselves. The plan: cruise in search of dolphins, whales and orcas, drop anchor at a gorgeous little beach for an ocean swim, and yes \u2014 drinks, wine and beer are all on the house. Sun, sea and good vibes all the way.",
  "ex_dur_yacht-cruise-puerto-colon": "3 hrs",
  "ex_hl_yacht-cruise-puerto-colon_0": "Dolphin, whale and orca spotting cruise \u2014 these waters are teeming with marine life",
  "ex_hl_yacht-cruise-puerto-colon_1": "Swim stop at a secluded beach in crystal-clear Atlantic water",
  "ex_hl_yacht-cruise-puerto-colon_2": "Maximum 11 people on board \u2014 intimate atmosphere, zero crowds",
  "ex_hl_yacht-cruise-puerto-colon_3": "Drinks, wine and beer included \u2014 sail in style",
  "ex_inc_yacht-cruise-puerto-colon_0": "3-hour yacht cruise",
  "ex_inc_yacht-cruise-puerto-colon_1": "Drinks, wine and beer on board",
  "ex_inc_yacht-cruise-puerto-colon_2": "Beach swim stop",
  "ex_rec_yacht-cruise-puerto-colon_0": "Bring swimwear, a towel and sunscreen \u2014 you\u2019ll want to jump straight in",
  "ex_rec_yacht-cruise-puerto-colon_1": "If you\u2019re a bigger group (8\u201311 people), book ahead \u2014 spots disappear fast",
  "ex_var_yacht-cruise-puerto-colon_0": "Adult",

  // ─── Aqualand Costa Adeje
  "ex_title_aqualand-costa-adeje": "Aqualand Costa Adeje — Water Park",
  "ex_subtitle_aqualand-costa-adeje": "Tenerife's largest south-coast water park with its own dolphin show",
  "ex_tagline_aqualand-costa-adeje": "Aqualand isn't just a water park — it has its very own dolphinarium with 10 dolphins, five of which were born and raised right here. Kamikaze, Super Slalom, Twister, Anaconda, Crazy Race and the brand-new Boomerang keep the thrill-seekers busy, while the dolphin spectacular is something genuinely special. Free bus from Los Cristianos, Las Américas and Costa Adeje included. Open Sep–Jun 10:00–17:30, Jul–Aug 10:00–18:00.",
  "ex_dur_aqualand-costa-adeje": "4 – 5 hrs",
  "ex_hl_aqualand-costa-adeje_0": "Own dolphinarium with live shows — the dolphins are the real stars here",
  "ex_hl_aqualand-costa-adeje_1": "Kamikaze, Super Slalom, Twister, Anaconda — classic slides plus the new-generation Boomerang",
  "ex_hl_aqualand-costa-adeje_2": "Mini Park zone for the youngest visitors — safe water fun for small kids",
  "ex_hl_aqualand-costa-adeje_3": "Free bus service from Los Cristianos, Las Américas and Costa Adeje",
  "ex_inc_aqualand-costa-adeje_0": "Park entrance ticket",
  "ex_inc_aqualand-costa-adeje_1": "Free shuttle bus from South Tenerife",
  "ex_rec_aqualand-costa-adeje_0": "Check dolphin show times — Sep–Jun 15:30, Jul–Aug 12:45 and 15:30",
  "ex_rec_aqualand-costa-adeje_1": "Park closes at 17:30 in winter and 18:00 in summer — plan your visit accordingly",
  "ex_var_aqualand-costa-adeje_0": "Adult ticket",
  "ex_var_aqualand-costa-adeje_1": "Child (5–10 yrs)",
  "ex_var_aqualand-costa-adeje_2": "Infant (3–4 yrs)",

  // ─── Siam Park
  "ex_title_siam-park-tenerife": "Siam Park — World's Best Water Park",
  "ex_subtitle_siam-park-tenerife": "7-time world's best water park according to TripAdvisor",
  "ex_tagline_siam-park-tenerife": "Siam Park has been voted the best water park in the world seven times in a row — and you'll see why immediately. Tower of Power is a 28-metre near-vertical plunge through an aquarium full of sharks and rays. Singha is the world's fastest water coaster with 14 direction changes. Siam Beach is 13,000 m² of white sand and a genuine wave pool. Sun loungers and parasols included in the ticket price. Summer hours 10–18, winter 10–17.",
  "ex_dur_siam-park-tenerife": "5 hrs",
  "ex_hl_siam-park-tenerife_0": "Tower of Power — 28-metre plunge through a live aquarium of sharks and rays",
  "ex_hl_siam-park-tenerife_1": "Singha — world's fastest water coaster with 250 metres of track and 14 direction changes",
  "ex_hl_siam-park-tenerife_2": "Siam Beach — 13,000 m² of white sand, wave pool, and sun loungers included in ticket price",
  "ex_hl_siam-park-tenerife_3": "Coco Beach — dedicated water zone for young children with age-appropriate attractions",
  "ex_inc_siam-park-tenerife_0": "Park entrance ticket",
  "ex_inc_siam-park-tenerife_1": "Sun loungers and parasols all day",
  "ex_rec_siam-park-tenerife_0": "Get there right at opening — Tower of Power queues are shortest first thing",
  "ex_rec_siam-park-tenerife_1": "Book the bus transfer from Puerto de la Cruz in advance — it fills up fast",
  "ex_hrs_siam-park-tenerife_0_name": "Summer (May – Oct)",
  "ex_hrs_siam-park-tenerife_0_info": "10:00 – 18:00",
  "ex_hrs_siam-park-tenerife_1_name": "Winter (Nov – Apr)",
  "ex_hrs_siam-park-tenerife_1_info": "10:00 – 17:00",
  "ex_var_siam-park-tenerife_0": "Adult ticket",
  "ex_var_siam-park-tenerife_1": "Resident ticket",
  "ex_var_siam-park-tenerife_2": "Transfer from Puerto de la Cruz",

  // ─── Loro Parque
  "ex_title_loro-parque-tenerife": "Loro Parque — World's Best Zoo",
  "ex_subtitle_loro-parque-tenerife": "Sanctuary for 400+ species with orca, dolphin and parrot shows",
  "ex_tagline_loro-parque-tenerife": "Loro Parque isn't your average zoo. Every animal has an individually tailored care plan drawn up by expert vets. Orcas, dolphins, sea lions, parrots, tigers, penguins — over 400 species spread across beautifully landscaped grounds in Puerto de la Cruz. Multiple shows daily. And yes, it really has been voted the world's best zoo by TripAdvisor.",
  "ex_dur_loro-parque-tenerife": "5 hrs",
  "ex_hl_loro-parque-tenerife_0": "Orca show — twice daily at 11:55 and 15:15, a genuinely breathtaking display",
  "ex_hl_loro-parque-tenerife_1": "Dolphin, sea lion and parrot shows — each 20 minutes, schedule included with your ticket",
  "ex_hl_loro-parque-tenerife_2": "White tigers, alligators, gorillas, penguins and over 400 other species",
  "ex_hl_loro-parque-tenerife_3": "Free bus from South Tenerife or hotel transfer directly to the park",
  "ex_inc_loro-parque-tenerife_0": "Full entrance ticket",
  "ex_rec_loro-parque-tenerife_0": "Arrive early — gates open at 9:30. First orca show at 11:55",
  "ex_rec_loro-parque-tenerife_1": "Free train connects Puerto de la Cruz harbour to the park — alight at the Loro Parque stop",
  "ex_var_loro-parque-tenerife_0": "Adult ticket",
  "ex_var_loro-parque-tenerife_1": "Resident ticket",
  "ex_var_loro-parque-tenerife_2": "Ticket + bus",
  "ex_var_loro-parque-tenerife_3": "Transfer",
  "ex_sch_loro-parque-tenerife_0": "Sea Lions Show",
  "ex_sch_loro-parque-tenerife_1": "Loro Show (parrots)",
  "ex_sch_loro-parque-tenerife_2": "Dolphin Show",
  "ex_sch_loro-parque-tenerife_3": "Orca Show",

  // ─── Castillo San Miguel
  "ex_title_castillo-san-miguel": "Castillo San Miguel — Medieval Evening",
  "ex_subtitle_castillo-san-miguel": "A jousting tournament with medieval banquet at Count Don Rodrigo's castle",
  "ex_tagline_castillo-san-miguel": "You walk into Count Don Rodrigo's castle, hear hooves on sand, and there's a 50-metre jousting arena right in front of you. Knights in full armour compete, the crowd picks a champion to cheer for — and you eat a whole chicken with your hands while drinking wine from the jug. Exactly the kind of medieval evening you imagined. Shows on Tuesdays, Thursdays and Saturdays.",
  "ex_dur_castillo-san-miguel": "3 hrs",
  "ex_hl_castillo-san-miguel_0": "Authentic jousting tournament on a 50-metre sand arena — cheer for one of 6 knights",
  "ex_hl_castillo-san-miguel_1": "Medieval banquet: soup from the bowl, chicken eaten by hand, unlimited wine and juice",
  "ex_hl_castillo-san-miguel_2": "After the tournament — the Ballroom with music and dancing to round off the night",
  "ex_hl_castillo-san-miguel_3": "Hotel transfer from South Tenerife available as an add-on option",
  "ex_inc_castillo-san-miguel_0": "Show entrance",
  "ex_inc_castillo-san-miguel_1": "Medieval dinner with wine and juice",
  "ex_req_castillo-san-miguel_0": "Shows run Tuesdays, Thursdays and Saturdays only. Reception from 18:30, show starts 19:30",
  "ex_rec_castillo-san-miguel_0": "Book the transfer — the venue is outside the main resort area, hard to reach by taxi on time",
  "ex_rec_castillo-san-miguel_1": "Vegetarian menu available — let us know when booking",
  "ex_var_castillo-san-miguel_0": "Show + Dinner",
  "ex_var_castillo-san-miguel_1": "Show + Dinner VIP",
  "ex_var_castillo-san-miguel_2": "Show + Dinner + Transfer",

  // ─── Sea Fishing Trip
  "ex_title_sea-fishing-tenerife": "Sea Fishing Trip — Tenerife",
  "ex_subtitle_sea-fishing-tenerife": "Whole boat just for you — deep-sea fishing off South Tenerife",
  "ex_tagline_sea-fishing-tenerife": "Hop on board and spend unforgettable hours at sea. The whole boat is just for you, max 4 people, €120 per hour. Perfect for families, friends or a small group of anglers. No experience needed — it's all about good fun, the open ocean and the thrill of the catch!",
  "ex_dur_sea-fishing-tenerife": "3 – 4 hrs",
  "ex_hl_sea-fishing-tenerife_0": "Whole boat exclusively for your group — private trip, max 4 people on board",
  "ex_hl_sea-fishing-tenerife_1": "€120 / hour — flexible duration: 3 hours (€360) or 4 hours (€480)",
  "ex_hl_sea-fishing-tenerife_2": "Deep-sea fishing off South Tenerife with an experienced skipper and full gear provided",
  "ex_hl_sea-fishing-tenerife_3": "No experience required — the skipper guides you, you just enjoy and reel in the fish",
  "ex_inc_sea-fishing-tenerife_0": "Private boat with experienced skipper",
  "ex_inc_sea-fishing-tenerife_1": "Full fishing tackle and bait",
  "ex_inc_sea-fishing-tenerife_2": "Drinks on board",
  "ex_inc_sea-fishing-tenerife_3": "Help with preparing your catch",
  "ex_rec_sea-fishing-tenerife_0": "Bring sunscreen, a hat and sunglasses — the sun is intense out at sea",
  "ex_rec_sea-fishing-tenerife_1": "Comfortable shoes with non-slip soles — the deck can get wet",
  "ex_req_sea-fishing-tenerife_0": "Basic swimming ability required",
  "ex_var_sea-fishing-tenerife_0": "3 hours",
  "ex_var_sea-fishing-tenerife_1": "4 hours",

  // ─── Anaga Mountain Hike
  "ex_title_anaga-mountain-hike": "Anaga Magical Mountain Hike",
  "ex_subtitle_anaga-mountain-hike": "A short, intense hike through the mysterious laurel forest and breathtaking views",
  "ex_tagline_anaga-mountain-hike": "Set off in a small group and discover one of Tenerife's most extraordinary places. The mysterious laurel forest, mist drifting between the ferns and spectacular views over valleys and ravines await you. It's a short, intense dose of nature that stays with you for a long time!",
  "ex_dur_anaga-mountain-hike": "2.5 – 3 hrs",
  "ex_hl_anaga-mountain-hike_0": "Mysterious laurel forest — ancient nature listed as a UNESCO World Heritage Site",
  "ex_hl_anaga-mountain-hike_1": "Fog, ferns and a unique, almost fairytale atmosphere in the Anaga ravines",
  "ex_hl_anaga-mountain-hike_2": "Spectacular views over valleys and ravines from mountain viewpoints",
  "ex_hl_anaga-mountain-hike_3": "Small group — maximum 10 people to keep the atmosphere intimate",
  "ex_inc_anaga-mountain-hike_0": "Experienced local mountain guide",
  "ex_inc_anaga-mountain-hike_1": "Hike in a small group (max 10 people)",
  "ex_inc_anaga-mountain-hike_2": "Insurance during the hike",
  "ex_req_anaga-mountain-hike_0": "Basic fitness — easy to moderate level",
  "ex_req_anaga-mountain-hike_1": "Bring your own water and snacks",
  "ex_rec_anaga-mountain-hike_0": "Comfortable hiking shoes are essential — the route follows forest trails",
  "ex_rec_anaga-mountain-hike_1": "Bring a light jacket and layers — it's misty and humid in the laurel forest",
  "ex_rec_anaga-mountain-hike_2": "Transport to the starting point is arranged individually — ask when booking",
  "ex_var_anaga-mountain-hike_0": "Person (min. 3 people)",
};